/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_FromInputs */

const en_cargos_sales_range_from = /** @type {(inputs: Cargos_Sales_Range_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const es_cargos_sales_range_from = /** @type {(inputs: Cargos_Sales_Range_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Cargos_Sales_Range_FromInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_from = /** @type {((inputs?: Cargos_Sales_Range_FromInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_FromInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_from(inputs)
	return es_cargos_sales_range_from(inputs)
});